import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../contexts/TranslationContext';
import Button from '../Button';
import './ApptCancellationPage.css';

const ApptCancellationPage = ({ apptType }) => {
  const { translate } = useTranslation();
  const navigate = useNavigate();

  const handleReturnBtnClicked = () => {
    if (apptType === 'service') {
      navigate('/services');
    } else if (apptType === 'class') {
      navigate('/classes');
    }
  };

  const getStringsKey = () => {
    if (apptType === 'service') {
      return 'servicesApptCancellationPage';
    } else if (apptType === 'class') {
      return 'classesApptCancellationPage';
    }
  };

  const stringsKey = getStringsKey();

  return (
    <div className="appt-cancellation-container">
      <h1>{translate(stringsKey + '.header.title')}</h1>
      <p>{translate(stringsKey + '.content.p1')}</p>
      <p>{translate(stringsKey + '.content.p2')}</p>
      <Button size="medium" onClick={handleReturnBtnClicked}>
        {translate(stringsKey + '.returnBtn')}
      </Button>
    </div>
  );
};

export default ApptCancellationPage;
